const APP_CONFIG = {
  version: "7.94.0",
  title: "Claire V7.94.0",
  version_client: "7.94.0",
};

export default APP_CONFIG;
